import pgaFormReducer  from './pgaFormReducer';
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./authReducer";
import producerReducer from "./producerReducer";
import dashboardReducer from "./dashboardReducer";
import remittanceReducer from "./remittanceReducer";
import performanceReducer from "./performanceReducer";
import notificationReducer from "./notificationReducer";

export const RESET_STORE = "RESET_STORE";
export const resetStore = () => ({ type: RESET_STORE });

const appReducer = combineReducers({
  auth: authReducer,
  producer: producerReducer,
  dashboard: dashboardReducer,
  remittance: remittanceReducer,
  notification: notificationReducer,
  performance: performanceReducer,
  pgaForm: pgaFormReducer
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
});
